function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import atIds from "@brandwatch/axiom-automation-testing/ids";
import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import omit from "lodash.omit";
import { ALERT_ICON_NAME_MAP } from "../AlertIcon/AlertIcon";
import Base from "../Base/Base";
import Icon from "../Icon/Icon";
import Link from "../Typography/Link";
import ProgressInfinite from "../Progress/ProgressInfinite";
import "./Notification.css";
export default class Notification extends Component {
  componentDidMount() {
    const {
      onAppear
    } = this.props;

    if (onAppear) {
      onAppear();
    }
  }

  render() {
    const {
      children,
      type,
      onRemoveClick,
      ...rest
    } = this.props;
    const classes = classnames("ax-notification", `ax-notification--${type}`);
    return /*#__PURE__*/React.createElement(Base, _extends({}, omit(rest, ["onAppear"]), {
      className: classes,
      textColor: "subtle"
    }), /*#__PURE__*/React.createElement("div", {
      className: "ax-notification__icon"
    }, type === "loading" ? /*#__PURE__*/React.createElement(ProgressInfinite, {
      sizeRem: "2rem"
    }) : /*#__PURE__*/React.createElement(Icon, {
      name: ALERT_ICON_NAME_MAP[type],
      size: "2rem"
    })), /*#__PURE__*/React.createElement("div", {
      className: "ax-notification__messsage"
    }, children), onRemoveClick && /*#__PURE__*/React.createElement("div", {
      className: "ax-notification__remove"
    }, /*#__PURE__*/React.createElement(Link, {
      "data-ax-at": atIds.Notification.close,
      onClick: () => onRemoveClick(),
      style: "subtle"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "cross"
    }))));
  }

}